<template>
  <div class="float-qr-container" :class="{ collapsed: isCollapsed }">
    <!-- 展开/收起按钮 -->
    <div 
      class="float-toggle-btn" 
      @click.stop="toggleCollapse"
      @touchstart.stop="handleTouchStart"
    >
      <i :class="isCollapsed ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"></i>
    </div>
    
    <!-- 二维码内容 -->
    <div class="float-qr-content" v-show="!isCollapsed">
      <div class="qr-header">
        <h4>扫码关注</h4>
        <i class="el-icon-close close-btn" @click="isCollapsed = true"></i>
      </div>
      
      <div class="qr-items">
        <div class="qr-item">
          <div class="qr-title">小程序</div>
          <img :src="xiaochengxuImg" alt="小程序二维码" class="qr-image">
        </div>
        
        <div class="qr-item">
          <div class="qr-title">公众号</div>
          <img :src="gongzhonghaoImg" alt="公众号二维码" class="qr-image">
        </div>
        <div class="qr-item">
          <div class="qr-title">微信群聊</div>
          <img :src="vxqunliaoImg" alt="微信群聊二维码" class="qr-image">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatQRCode',
  data() {
    return {
      isCollapsed: true, // 默认收起状态
      xiaochengxuImg: require('@/assets/xiaochengxu.jpg'),
      gongzhonghaoImg: require('@/assets/gongzhonghao.jpg'),
      vxqunliaoImg: require('@/assets/vxqunliaoImg.png'),

      touchTriggered: false
    }
  },
  methods: {
    toggleCollapse() {
      // 如果触摸事件已触发，忽略点击事件
      if (this.touchTriggered) {
        this.touchTriggered = false
        return
      }
      this.isCollapsed = !this.isCollapsed
    },
    handleTouchStart(e) {
      // 移动端触摸时立即触发，避免点击延迟
      e.stopPropagation()
      this.touchTriggered = true
      this.isCollapsed = !this.isCollapsed
      // 延迟重置标志，防止点击事件触发
      setTimeout(() => {
        this.touchTriggered = false
      }, 300)
    }
  }
}
</script>

<style scoped>
.float-qr-container {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  display: flex;
  align-items: center;
}

.float-toggle-btn {
  position: relative;
  width: 40px;
  height: 80px;
  background: linear-gradient(135deg, #ff8a2d 0%, #ff6723 100%);
  border-radius: 8px 0 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  font-size: 18px;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  touch-action: manipulation;
  z-index: 1001;
  flex-shrink: 0;
}

.float-qr-content {
  position: relative;
  width: 180px;
  background: #fff;
  border-radius: 8px 0 0 8px;
  box-shadow: -2px 0 12px rgba(0, 0, 0, 0.15);
  padding: 16px;
  transition: all 0.3s ease;
  margin-right: 0;
  transform: translateX(100%);
  opacity: 0;
  pointer-events: none;
}

.float-qr-container:not(.collapsed) .float-qr-content {
  transform: translateX(0);
  opacity: 1;
  pointer-events: auto;
}

.float-toggle-btn:hover {
  background: linear-gradient(135deg, #ff9a4d 0%, #ff7743 100%);
  box-shadow: -2px 0 12px rgba(0, 0, 0, 0.2);
}


.qr-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.qr-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.close-btn {
  cursor: pointer;
  color: #909399;
  font-size: 16px;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #ff6f2f;
}

.qr-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.qr-item {
  text-align: center;
}

.qr-title {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.qr-image {
  width: 100%;
  max-width: 140px;
  height: auto;
  border: 1px solid #eee;
  border-radius: 4px;
  display: block;
  margin: 0 auto;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .float-toggle-btn {
    width: 45px;
    height: 70px;
    font-size: 18px;
    min-width: 45px;
    min-height: 70px;
  }
  
  .float-qr-content {
    width: 160px;
    padding: 12px;
  }
  
  .qr-image {
    max-width: 120px;
  }
  
  .close-btn {
    min-width: 24px;
    min-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

